// extracted by mini-css-extract-plugin
export default {"dark":"#141414","darkShade1":"#1d2226","darkShade2":"#39434f","darkShade3":"#383d40","darkShade4":"rgba(255,255,255,.67)","dpdRed":"#dc0032","linkColor":"#3d74d5"};